import { useNavigate } from "react-router-dom";
import { FormattedContent, WebinarContent } from "../../../../../@types";
import { formatDateRange } from "../../../../../utils";

export function WebinarPreview({ webinars }: { webinars: FormattedContent[] }) {
  return (
    <>
      {webinars.map((a: FormattedContent) => (
        <ExternalWebinarContentTeaser webinar={a as WebinarContent} />
      ))}
    </>
  );
}

export function ExternalWebinarContentTeaser({
  webinar,
}: {
  webinar: WebinarContent;
}) {
  const navigate = useNavigate();

  const handleArticleClick = () => {
    navigate(`/community/webinars/${webinar?.id}`);
  };

  return (
    <div className="w-full">
      <>
        <div
          onClick={handleArticleClick}
          className="flex flex-col items-start mb-2"
        >
          <div className="flex flex-col sm:flex-row mb-4 w-full">
            {webinar?.image && (
              <div className="w-full mb-4 sm:mb-0 sm:mr-4 sm:w-72 h-fit rounded-lg overflow-hidden">
                <img src={webinar?.image} alt="article-image" />
              </div>
            )}
            <div className="w-full">
              <h2 className="font-bold text-xl mb-1">{webinar?.title}</h2>
              <p className="text-md text-Yellow-default font-bold mb-2">
                {((webinar as WebinarContent)?.hosts || [])
                  .map(
                    (host) => `${host.fields.givenName} ${host.fields.surname}`
                  )
                  .join(", ")}
              </p>

              <p className="text-sm font-medium mb-2">
                {formatDateRange(
                  (webinar as WebinarContent)?.startDate,
                  (webinar as WebinarContent)?.endDate
                )}
              </p>
              <h3 className="overflow-hidden">
                {webinar?.teaserText?.slice(0, 170)}...
              </h3>
            </div>
          </div>

          <hr className="border-xs border-zinc-300 w-full mb-4" />
        </div>
      </>
    </div>
  );
}
